<template>
  <div class="courses">
    <div>
      <h1 class="title text-3xl font-bold text-gray-900 mb-4">My Courses</h1>

      <div class="course-card" :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color') + '20' }">
        <div v-if="!isCourseLoading">
          <div v-if="assignedCourse">
            <div class="course-image-placeholder">
              <div v-if="isImageLoading" class="course-image-skeleton" />
              <img
                v-if="assignedCourse.image_url"
                class="course-image"
                :class="{ 'course-image-hidden': isImageLoading }"
                :src="assignedCourse.image_url"
                alt=""
                @load="handleCourseImageLoad"
                @error="handleCourseImageLoad"
              />
            </div>
            <p class="enrollment-text">You are currently enrolled in the {{ assignedCourse.title }} course.</p>
          </div>
          <div v-else class="enrollment-text">
            <p>You are currently not enrolled in any course.</p>
          </div>
          <div class="button-group">
            <button
              @click="openLMS()"
              class="launch-button"
              :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color'), color: 'white' }"
            >
              LAUNCH COURSE <i class="fas fa-external-link-alt ml-2"></i>
            </button>
            <!-- This button remains disabled as tracking progress requires an assigned course -->

          </div>
        </div>
        <div v-else>
          <i class="fas fa-circle-notch fa-spin text-muted" style="font-size:30px;"></i>
        </div>
      </div>

      <!-- <div class="history-section">
        <a
          href="#"
          class="history-link"
          :style="{
            color: get(getLoggedInUser, 'linked_entity.primary_color'),
          }"
          >View history from other courses</a
        >
        <p class="history-description">
          Access your completed courses and certificates from previous enrollments.
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

// import Page from '@/components/Page.vue';

export default {
  name: 'CourseHome',
  // extends: Page,
  data() {
    return {
      assignedCourse: null,
      isCourseLoading: false,
      isImageLoading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    ...mapActions('courses', ['getStdAssignedCourse']),
    ...mapActions('auth', ['generateTemporaryToken']),
    get,
    async fetchStudentAssignedCourse() {
      this.isCourseLoading = true;
      try {
        const resp = await this.getStdAssignedCourse();
        // Check if we have course data with a title
        this.assignedCourse = resp.data && resp.data.title ? resp.data : null;
        this.isImageLoading = Boolean(this.assignedCourse && this.assignedCourse.image_url);
      } catch (error) {
        // Handle error silently or use a toast notification if available
        if (this.$root.$bvToast) {
          this.$root.$bvToast.toast('Error fetching course information', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } finally {
        this.isCourseLoading = false;
      }
    },

    handleCourseImageLoad() {
      this.isImageLoading = false;
    },

    async openLMS() {
      const url = get(this.getLoggedInUser, 'linked_entity.lms_subdomain.subdomain_url');
      try {
        const res = await this.generateTemporaryToken({ launch_course: 1 });
        setTimeout(() => {
          window.open(`${url}/?token=${res.temporary_token}`, '_blank');
        });
      } catch (e) {
        // Use Bootstrap Vue toast if available
        if (this.$root.$bvToast) {
          this.$root.$bvToast.toast(`Couldn't redirect to LMS. Please try again.`, {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
        throw e;
      }
    },
  },
  mounted() {
    this.fetchStudentAssignedCourse();
  },
};
</script>

<style scoped>
.courses {
  min-height: 100vh;
  padding: 2rem 1rem;
}

.title {
  text-align: center;
  font-size: 2rem;
  font-weight: 800;
}

.course-card {
  border-radius: 12px;
  padding: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  width: 80%;
  justify-self: center;
}

.course-image-placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin: 0 auto 2rem auto;
  padding: 0.5rem;
  max-width: 100%;
}

.course-image {
  display: block;
  width: auto;
  height: 200px;
  max-width: 100%;
  border-radius: 6px;
}

.course-image-hidden {
  opacity: 0;
}

.course-image-skeleton {
  width: 320px;
  max-width: 100%;
  height: 200px;
  border-radius: 6px;
  background: linear-gradient(90deg, #cbd5e0 25%, #e2e8f0 37%, #cbd5e0 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.enrollment-text {
  font-size: 1.125rem;
  color: #2d3748;
  margin-bottom: 2rem;
  font-weight: 700;
}

.button-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.launch-button {
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.025em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.track-button {
  background-color: white;
  color: #3182ce;
  border: 1px solid #3182ce;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.025em;
  cursor: pointer;
  transition: all 0.2s ease;
}

.track-button:hover {
  background-color: #f7fafc;
}

.history-section {
  text-align: center;
  margin-top: 2rem;
}

.history-link {
  color: #3182ce;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  display: block;
  margin-bottom: 0.5rem;
}

.history-link:hover {
  text-decoration: underline;
}

.history-description {
  color: #718096;
  font-size: 0.875rem;
  margin: 0;
}

@media (max-width: 640px) {
  .container {
    padding: 0 0.5rem;
  }

  .course-card {
    padding: 1.5rem;
  }

  .button-group {
    flex-direction: column;
    gap: 0.75rem;
  }

  .launch-button,
  .track-button {
    width: 100%;
    max-width: 280px;
  }

  .title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
}
</style>
